import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Shield, Car, Home, Zap, ArrowRight, Star, Heart } from 'lucide-react';
import { SimonsHeader, SimonsFooter } from '../components/SimonsNavigation';
export function SimonsPersonal({
  onBack,
  setActivePage
}: {
  onBack: () => void;
  setActivePage: (p: any) => void;
}) {
  const [bundle, setBundle] = useState(true);
  return <div className="min-h-screen bg-white text-[#002366] font-sans" data-id="element-1830">
      <SimonsHeader activePage="personal" setActivePage={setActivePage} data-id="element-1831" />

      {/* Hero Section */}
      <section className="py-24 px-8 max-w-5xl mx-auto text-center" data-id="element-1832">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} data-id="element-1833">
          <h1 className="text-5xl lg:text-7xl font-black mb-8 tracking-tighter" data-id="element-1834">
            Bundle & <span className="text-[#002366]" data-id="element-1835">Save.</span>
          </h1>
          <p className="text-xl text-slate-500 mb-12 font-medium max-w-2xl mx-auto" data-id="element-1836">
            Minimalist protection for your most important assets. Get an instant
            price review in seconds.
          </p>

          <div className="inline-flex items-center p-2 bg-slate-100 rounded-2xl mb-16" data-id="element-1837">
            <button onClick={() => setBundle(false)} className={`px-8 py-3 rounded-xl font-bold text-sm transition-all ${!bundle ? 'bg-white shadow-sm text-[#002366]' : 'text-slate-400'}`} data-id="element-1838">
              Single Policy
            </button>
            <button onClick={() => setBundle(true)} className={`px-8 py-3 rounded-xl font-bold text-sm transition-all ${bundle ? 'bg-white shadow-sm text-[#002366]' : 'text-slate-400'}`} data-id="element-1839">
              Auto + Home Bundle
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-1840">
            <div className="p-10 bg-slate-50 rounded-[32px] border border-slate-100 flex flex-col items-center" data-id="element-1841">
              <Car size={48} className="text-[#002366] mb-6" data-id="element-1842" />
              <h3 className="text-2xl font-black mb-2" data-id="element-1843">Auto Insurance</h3>
              <p className="text-slate-500 text-sm font-medium mb-8" data-id="element-1844">
                Modern coverage for the modern driver.
              </p>
              <button className="w-full py-4 bg-[#FFD700] text-[#002366] rounded-xl font-black uppercase tracking-widest text-xs hover:shadow-xl transition-all" data-id="element-1845">
                Instant Price Review
              </button>
            </div>
            <div className="p-10 bg-slate-50 rounded-[32px] border border-slate-100 flex flex-col items-center" data-id="element-1846">
              <Home size={48} className="text-[#002366] mb-6" data-id="element-1847" />
              <h3 className="text-2xl font-black mb-2" data-id="element-1848">Home Insurance</h3>
              <p className="text-slate-500 text-sm font-medium mb-8" data-id="element-1849">
                Protecting your sanctuary and wealth.
              </p>
              <button className="w-full py-4 bg-[#FFD700] text-[#002366] rounded-xl font-black uppercase tracking-widest text-xs hover:shadow-xl transition-all" data-id="element-1850">
                Instant Price Review
              </button>
            </div>
          </div>
        </motion.div>
      </section>

      {/* Trust Bar */}
      <section className="py-16 bg-slate-50 border-y border-slate-100" data-id="element-1851">
        <div className="max-w-7xl mx-auto px-8 flex flex-wrap justify-center items-center gap-16 opacity-40 grayscale" data-id="element-1852">
          <div className="h-6 w-24 bg-slate-400 rounded" data-id="element-1853"></div>
          <div className="h-6 w-24 bg-slate-400 rounded" data-id="element-1854"></div>
          <div className="h-6 w-24 bg-slate-400 rounded" data-id="element-1855"></div>
          <div className="h-6 w-24 bg-slate-400 rounded" data-id="element-1856"></div>
        </div>
      </section>

      <SimonsFooter data-id="element-1857" />
    </div>;
}